import { CheckoutRepository } from '@lib/api/repository/checkout/checkout.repository';
import {
  CheckoutAvailability,
  CheckoutBatchInput,
  CheckoutSession,
  CheckoutSessionInput,
  ShippingQuote,
  ShippingQuoteInput,
} from '@lib/types';

import { Requester } from '../clients';

export default class CheckoutAPI implements CheckoutRepository {
  async createBatch(input: CheckoutBatchInput) {
    return (
      await Requester.post<CheckoutSession[]>('/marketplace/checkout/batches', {
        body: {
          entries: input.entries.map((entry) => ({
            storeId: entry.storeId,
            addressId: entry.addressId,
            shippingQuoteId: entry.shippingQuoteId,
          })),
          couponCodes: input.couponCodes,
          idempotencyKey: input.idempotencyKey,
        },
      })
    ).data;
  }

  async getAvailability(signal?: AbortSignal) {
    return (
      await Requester.get<CheckoutAvailability>(
        '/marketplace/checkout/availability',
        { signal },
      )
    ).data;
  }

  async quoteShipping(input: ShippingQuoteInput) {
    return (
      await Requester.post<ShippingQuote[]>('/marketplace/shipping/quotes', {
        body: input,
      })
    ).data;
  }

  async createSession(input: CheckoutSessionInput) {
    return (
      await Requester.post<CheckoutSession>('/marketplace/checkout/sessions', {
        body: input,
      })
    ).data;
  }

  async findSession(id: string, signal?: AbortSignal) {
    return (
      await Requester.get<CheckoutSession>(
        `/marketplace/checkout/sessions/${id}`,
        { signal },
      )
    ).data;
  }

  async resumeOrderPayment(orderId: string) {
    return (
      await Requester.post<CheckoutSession>(
        `/marketplace/checkout/orders/${orderId}/payment`,
      )
    ).data;
  }
}
